import React from "react";
import "./StaticTooltip.css";

interface StaticTooltipProps {
  text: string;
  placement?: "top" | "left" | "right" | "bottom";
  children: React.ReactNode;
}

const TooltipWrapper: React.FC<StaticTooltipProps> = ({
  text,
  placement = "top",
  children,
}) => {
  if (!text) return <>{children}</>;
  return (
    <div className="tooltip-wrapper">
      <div className={`tooltip-box tooltip-${placement}`}>{text}</div>
      {children}
    </div>
  );
};

export default TooltipWrapper;
